/** TEMPORARY DATA! Need to prioritize adding this to API */
export const HardcodedRegions: Record<string, any>[] = [
  { text: 'Worldwide', value: 'WWD', index: 'WWD' },
  { text: 'Worldwide (excluding USA & Nepal)', value: 'WWE', index: 'WWE' },
  { text: 'Europe', value: 'ERP', index: 'ERP' },
  { text: 'Asia (excl. Nepal)', value: 'AEN', index: 'AEN' },
  { text: 'Asia (incl. Nepal)', value: 'AIN', index: 'AIN' },
  { text: 'Africa', value: 'AFR', index: 'AFR' },
];

export const BrandHardcodedRegions: Record<string, Record<string, any>[]> = {
  sv: [
    { text: 'Europe', value: 'ERP', index: 'ERP' },
    { text: 'Worldwide (excluding USA)', value: 'WWU', index: 'WWU' },
    { text: 'Worldwide (including USA)', value: 'WWD', index: 'WWD' },
  ],
  wn: HardcodedRegions,
};
